/*
  OyeGifts Animated Micro Marketing Badges
  File: assets/ribbon-badges.js

  - Product image stays completely clean.
  - Small marketing badge appears above price.
  - Same product gets the same badge.
  - About 40% products show a badge.
  - Selected badges smoothly flip; text + background color both change.
  - All badge text is 13px on desktop and mobile.
  - Collection / search / homepage / product page supported.
  - Dynamic / infinite-scroll products supported.
*/

(function () {
  "use strict";

  var SHOW_PERCENT = 40;

  var STYLE_ID = "og-oygifts-badge-style";
  var ROW_CLASS = "og-oygifts-badge-row";
  var BADGE_CLASS = "og-oygifts-badge";

  var observerTimer = null;

  var BADGES = [
    {
      front: "BESTSELLER",
      frontClass: "red",
      back: "TRENDING",
      backClass: "yellow"
    },
    {
      front: "PREMIUM",
      frontClass: "black",
      back: "SIGNATURE PICK",
      backClass: "navy"
    },
    {
      front: "RECOMMENDED",
      frontClass: "orange",
      back: "POPULAR PICK",
      backClass: "purple"
    },
    {
      front: "BEST VALUE",
      frontClass: "teal",
      back: "SMART PICK",
      backClass: "green"
    },
    {
      front: "MOST LOVED",
      frontClass: "pink",
      back: "HOT PICK",
      backClass: "red"
    },
    {
      front: "NEW ARRIVAL",
      frontClass: "blue",
      back: "JUST IN",
      backClass: "teal"
    },
    {
      front: "TOP CHOICE",
      frontClass: "purple",
      back: "CUSTOMER PICK",
      backClass: "teal"
    },
    {
      front: "POPULAR",
      frontClass: "green",
      back: "IN DEMAND",
      backClass: "orange"
    },
    {
      front: "GIFTING PICK",
      frontClass: "rose",
      back: "LOVED CHOICE",
      backClass: "pink"
    },
    {
      front: "SPECIAL PICK",
      frontClass: "navy",
      back: "MUST TRY",
      backClass: "yellow"
    }
  ];

  var COLOR_CLASSES = [
    "red",
    "yellow",
    "black",
    "orange",
    "teal",
    "pink",
    "purple",
    "blue",
    "green",
    "rose",
    "navy"
  ];

  function isProductPage() {
    return location.pathname.indexOf("/products/") === 0;
  }

  function isListingPage() {
    return (
      location.pathname === "/" ||
      location.pathname.indexOf("/collections/") === 0 ||
      location.pathname.indexOf("/search") === 0
    );
  }

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement("style");
    style.id = STYLE_ID;

    style.textContent = `
      .${ROW_CLASS}{
        display:block!important;
        width:100%!important;
        min-height:22px!important;
        margin:5px 0 5px!important;
        padding:0!important;
        line-height:1!important;
        box-sizing:border-box!important;
        perspective:500px!important;
      }

      .${BADGE_CLASS}{
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        width:auto!important;
        max-width:100%!important;
        min-height:20px!important;
        padding:4px 7px!important;
        border:0!important;
        border-radius:2px!important;
        box-shadow:none!important;
        font-family:inherit!important;
        font-size:10px!important;
        line-height:1!important;
        font-weight:800!important;
        letter-spacing:.08px!important;
        text-transform:none!important;
        white-space:nowrap!important;
        overflow:hidden!important;
        pointer-events:none!important;

        transform:rotateX(0deg)!important;
        transform-origin:center center!important;
        backface-visibility:hidden!important;
        -webkit-backface-visibility:hidden!important;

        opacity:1!important;
        will-change:transform,opacity,background-color!important;

        transition:
          transform .34s cubic-bezier(.4,0,.2,1),
          opacity .34s cubic-bezier(.4,0,.2,1),
          background-color .22s ease,
          color .22s ease!important;
      }

      .${BADGE_CLASS}.is-flip-out{
        transform:rotateX(90deg)!important;
        opacity:.15!important;
      }

      .${BADGE_CLASS}.is-flip-in{
        transform:rotateX(-90deg)!important;
        opacity:.15!important;
        transition:none!important;
      }

      .${BADGE_CLASS}.red{
        color:#fff!important;
        background:#b3193f!important;
      }

      .${BADGE_CLASS}.yellow{
        color:#493700!important;
        background:#ffd83d!important;
      }

      .${BADGE_CLASS}.black{
        color:#fff!important;
        background:#222!important;
      }

      .${BADGE_CLASS}.orange{
        color:#fff!important;
        background:#bc4b12!important;
      }

      .${BADGE_CLASS}.teal{
        color:#fff!important;
        background:#087f78!important;
      }

      .${BADGE_CLASS}.pink{
        color:#fff!important;
        background:#d83b7d!important;
      }

      .${BADGE_CLASS}.purple{
        color:#fff!important;
        background:#6941c6!important;
      }

      .${BADGE_CLASS}.blue{
        color:#fff!important;
        background:#2475c7!important;
      }

      .${BADGE_CLASS}.green{
        color:#fff!important;
        background:#198754!important;
      }

      .${BADGE_CLASS}.rose{
        color:#fff!important;
        background:#c03664!important;
      }

      .${BADGE_CLASS}.navy{
        color:#fff!important;
        background:#344054!important;
      }

      @media(max-width:749px){
        .${ROW_CLASS}{
          min-height:22px!important;
          margin:5px 0 5px!important;
        }

        .${BADGE_CLASS}{
          min-height:20px!important;
          padding:4px 7px!important;
          font-size:10px!important;
          border-radius:2px!important;
        }
      }

      @media(prefers-reduced-motion:reduce){
        .${BADGE_CLASS}{
          transition:background-color .2s ease,color .2s ease!important;
        }

        .${BADGE_CLASS}.is-flip-out,
        .${BADGE_CLASS}.is-flip-in{
          transform:none!important;
          opacity:1!important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function hash(value) {
    var str = String(value || "").toLowerCase();
    var h = 2166136261;

    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h +=
        (h << 1) +
        (h << 4) +
        (h << 7) +
        (h << 8) +
        (h << 24);
    }

    return h >>> 0;
  }

  function getHandle(url) {
    var match = String(url || "").match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function shouldShow(handle) {
    return hash(handle + ":oygifts-show") % 100 < SHOW_PERCENT;
  }

  function getBadgeData(handle) {
    return BADGES[
      hash(handle + ":oygifts-style") % BADGES.length
    ];
  }

  function getCard(link) {
    return (
      link.closest("[data-card]") ||
      link.closest(".ogp") ||
      link.closest(".grid__item") ||
      link.closest(".product-card-wrapper") ||
      link.closest(".card-wrapper") ||
      link.closest(".product-card") ||
      link.closest(".product-item") ||
      link.closest(".boost-pfs-filter-product-item") ||
      link.closest("li") ||
      link.parentElement
    );
  }

  function isExcluded(element) {
    return !!(
      element &&
      element.closest(
        "header,nav,footer,.header,.footer,.drawer,.menu-drawer,.cart,.cart-drawer,.cart-notification"
      )
    );
  }

  function findCardPrice(card) {
    if (!card) return null;

    return card.querySelector(
      ".f-price," +
      ".ogpr," +
      ".card-information .price," +
      ".card__information .price," +
      ".product-card__price," +
      ".boost-pfs-filter-product-item-price," +
      ".product-item__price," +
      ".price"
    );
  }

  function findCardInfo(card) {
    if (!card) return null;

    return card.querySelector(
      ".product-card__info," +
      ".oginfo," +
      ".card-information," +
      ".card__information," +
      ".product-card__info," +
      ".card-information__wrapper," +
      ".product-item__info"
    );
  }

  function findPDPPrice() {
    return document.querySelector(
      ".product__info-container .price," +
      ".product__info-wrapper .price," +
      ".product-single__price," +
      ".price.price--large," +
      ".product__price," +
      ".price"
    );
  }

  function removeOldMarketingBadges(scope) {
    var root = scope || document;

    root
      .querySelectorAll(
        ".og-product-badge,.og-fnp-badge-row,.og-fnp-badge"
      )
      .forEach(function (el) {
        el.remove();
      });

    root
      .querySelectorAll(".og-product-badge-host")
      .forEach(function (el) {
        el.classList.remove("og-product-badge-host");
      });
  }

  function cssEscape(value) {
    if (
      window.CSS &&
      typeof window.CSS.escape === "function"
    ) {
      return window.CSS.escape(value);
    }

    return String(value)
      .replace(/\\/g, "\\\\")
      .replace(/"/g, '\\"');
  }

  function clearColorClasses(badge) {
    for (var i = 0; i < COLOR_CLASSES.length; i++) {
      badge.classList.remove(COLOR_CLASSES[i]);
    }
  }

  function createRow(handle, productPage) {
    var data = getBadgeData(handle);

    var row = document.createElement("div");

    row.className =
      ROW_CLASS + (productPage ? " is-product" : "");

    row.setAttribute(
      "data-og-oygifts-handle",
      handle
    );

    var badge = document.createElement("span");

    badge.className =
      BADGE_CLASS + " " + data.frontClass;

    badge.textContent = data.front;

    badge.setAttribute(
      "data-front-text",
      data.front
    );

    badge.setAttribute(
      "data-front-class",
      data.frontClass
    );

    if (data.back && data.backClass) {
      badge.setAttribute(
        "data-back-text",
        data.back
      );

      badge.setAttribute(
        "data-back-class",
        data.backClass
      );

      badge.setAttribute(
        "data-flip",
        "true"
      );
    }

    row.appendChild(badge);

    return row;
  }

  function placeBeforePrice(priceEl, handle, productPage) {
    if (!priceEl || !handle) return;

    var parent = priceEl.parentElement;

    if (!parent) return;

    var existing = parent.querySelector(
      ':scope > .' +
      ROW_CLASS +
      '[data-og-oygifts-handle="' +
      cssEscape(handle) +
      '"]'
    );

    if (existing) return;

    parent
      .querySelectorAll(
        ":scope > ." + ROW_CLASS
      )
      .forEach(function (row) {
        row.remove();
      });

    if (!shouldShow(handle)) return;

    parent.insertBefore(
      createRow(handle, productPage),
      priceEl
    );
  }

  /*
    Smooth 3D flip:
    1) current face 0deg -> 90deg
    2) at hidden midpoint text + color changes
    3) new face -90deg -> 0deg
  */
  function flipBadge(badge) {
    if (!badge) return;
    if (badge.dataset.animating === "1") return;
    if (!document.documentElement.contains(badge)) return;

    var frontText =
      badge.getAttribute("data-front-text") || "";

    var frontClass =
      badge.getAttribute("data-front-class") || "";

    var backText =
      badge.getAttribute("data-back-text") || "";

    var backClass =
      badge.getAttribute("data-back-class") || "";

    if (
      !frontText ||
      !frontClass ||
      !backText ||
      !backClass
    ) {
      return;
    }

    badge.dataset.animating = "1";

    var showingBack =
      badge.dataset.showingBack === "1";

    badge.classList.remove("is-flip-in");
    badge.classList.add("is-flip-out");

    window.setTimeout(function () {
      if (!document.documentElement.contains(badge)) return;

      clearColorClasses(badge);

      showingBack = !showingBack;

      if (showingBack) {
        badge.textContent = backText;
        badge.classList.add(backClass);
        badge.dataset.showingBack = "1";
      } else {
        badge.textContent = frontText;
        badge.classList.add(frontClass);
        badge.dataset.showingBack = "0";
      }

      badge.classList.remove("is-flip-out");
      badge.classList.add("is-flip-in");

      /*
        Force browser to register -90deg state
        before animating back to 0deg.
      */
      void badge.offsetWidth;

      badge.classList.remove("is-flip-in");

      window.setTimeout(function () {
        badge.dataset.animating = "0";
      }, 380);

    }, 340);
  }

  function initBadgeFlip(badge) {
    if (!badge) return;

    if (
      badge.dataset.flipReady === "1" ||
      badge.getAttribute("data-flip") !== "true"
    ) {
      return;
    }

    badge.dataset.flipReady = "1";
    badge.dataset.showingBack = "0";
    badge.dataset.animating = "0";

    var row = badge.closest("." + ROW_CLASS);

    var handle = row
      ? (
          row.getAttribute(
            "data-og-oygifts-handle"
          ) || ""
        )
      : "";

    /*
      Slightly stagger every product so all cards
      do not animate together.
    */
    var firstDelay =
      1200 + (
        hash(handle + ":first-flip") % 1800
      );

    var repeatDelay =
      3800 + (
        hash(handle + ":repeat-flip") % 1500
      );

    window.setTimeout(function startFlipLoop() {
      if (!document.documentElement.contains(badge)) return;

      flipBadge(badge);

      window.setTimeout(
        startFlipLoop,
        repeatDelay
      );
    }, firstDelay);
  }

  function initAllFlips(scope) {
    var root = scope || document;

    root
      .querySelectorAll(
        "." +
        BADGE_CLASS +
        '[data-flip="true"]'
      )
      .forEach(function (badge) {
        initBadgeFlip(badge);
      });
  }

  function renderCollection() {
    if (!isListingPage()) return;

    var links =
      document.querySelectorAll(
        'a[href*="/products/"]'
      );

    var used = [];

    Array.prototype.forEach.call(
      links,
      function (link) {
        if (isExcluded(link)) return;

        var handle =
          getHandle(
            link.getAttribute("href")
          );

        var card =
          getCard(link);

        if (
          !handle ||
          !card ||
          used.indexOf(card) !== -1
        ) {
          return;
        }

        used.push(card);

        var priceEl =
          findCardPrice(card);

        if (priceEl) {
          placeBeforePrice(
            priceEl,
            handle,
            false
          );
        } else {
          var info =
            findCardInfo(card);

          if (
            info &&
            shouldShow(handle) &&
            !info.querySelector(
              "." +
              ROW_CLASS +
              '[data-og-oygifts-handle="' +
              cssEscape(handle) +
              '"]'
            )
          ) {
            info.appendChild(
              createRow(
                handle,
                false
              )
            );
          }
        }
      }
    );

    initAllFlips(document);
  }

  function renderProduct() {
    if (!isProductPage()) return;

    var handle =
      getHandle(location.pathname);

    if (!handle) return;

    var priceEl =
      findPDPPrice();

    if (!priceEl) return;

    placeBeforePrice(
      priceEl,
      handle,
      true
    );

    initAllFlips(document);
  }

  function render() {
    addStyles();

    /*
      Remove only old marketing badge implementation.
      Delivery promise script remains untouched.
    */
    removeOldMarketingBadges(document);

    if (isProductPage()) {
      renderProduct();
    } else if (isListingPage()) {
      renderCollection();
    }
  }

  function scheduleRender() {
    clearTimeout(observerTimer);

    observerTimer =
      window.setTimeout(function () {
        render();
      }, 180);
  }

  function init() {
    render();

    window.setTimeout(
      render,
      700
    );
  }

  if (
    document.readyState === "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      init,
      { once: true }
    );
  } else {
    init();
  }

  if (window.MutationObserver) {
    new MutationObserver(
      function (mutations) {
        for (
          var i = 0;
          i < mutations.length;
          i++
        ) {
          if (
            mutations[i].addedNodes &&
            mutations[i].addedNodes.length
          ) {
            scheduleRender();
            break;
          }
        }
      }
    ).observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  window.ogRefreshProductBadges =
    function () {
      render();
    };
})();
